import { Abi } from 'viem'
import { useAccount, useWaitForTransactionReceipt, useWriteContract } from 'wagmi'

import { useValueTokens } from '@/contexts/VaultTokensContext'
import seaAVAX from '@/contracts/seaAVAX'

const useDepositAVAX = (amount: bigint) => {
  const { chain } = useAccount()
  const { currentToken } = useValueTokens()

  const {
    writeContract: writeContract,
    data: hash,
    isPending,
    error: writeError,
  } = useWriteContract()

  const {
    isLoading,
    isSuccess,
    data: receipt,
    isError,
  } = useWaitForTransactionReceipt({
    hash,
  })

  const handleWrite = async () => {
    const contractData: any = {
      abi: seaAVAX as Abi,
      address: currentToken.tokenAddresses[1][chain?.id] as `0x${string}`,
      functionName: 'depositAVAX',
      value: amount,
    }
    writeContract({
      ...contractData,
    })
  }

  return {
    hash,
    isPending,
    writeError,
    isLoading,
    isSuccess,
    receipt,
    isError,
    deposit: () => handleWrite(),
  }
}

export default useDepositAVAX
